import { TimeFrame, UpdateTimeFrameBulkInput, UpdateTimeFrameBulkResponse, UpdateTimeFrameInput } from '@/models/gen/graphql';
import { Validation, generateUpdateBulkPayload } from '@/utils';

import { GraphApiResponse } from '@/api/core';
import { UpdateTimeFrameBulkDocument } from '@/api/queries';
import { createTimeFrameValidator } from './createTimeFrameBulk';
import graphApi from '@/api';

type UpdateTimeFrameBulkGraphApiResponse = GraphApiResponse<typeof UpdateTimeFrameBulkDocument>;

const updateTimeFrameValidator = new Validation.Validator(
  {
    'id!': (val: any): Validation.Validity => ({ valid: Validation.isValidUUID(val) }),
  },
  createTimeFrameValidator
);

const updateTimeFrameBulkResponseSelector = (res: UpdateTimeFrameBulkGraphApiResponse): UpdateTimeFrameBulkResponse =>
  !res.errors ? res?.updateTimeFrameBulk : undefined;

const [runUpdateTimeFrameBulk] = graphApi(UpdateTimeFrameBulkDocument);

const updateTimeFrameBulk = async (timeFrames: Partial<TimeFrame>[]): Promise<UpdateTimeFrameBulkResponse> => {
  timeFrames = timeFrames.map((timeFrame: TimeFrame): TimeFrame => updateTimeFrameValidator.partial(timeFrame));
  const updates: UpdateTimeFrameInput[] = generateUpdateBulkPayload(timeFrames);
  const input: UpdateTimeFrameBulkInput = {
    updates,
  };
  const res = await runUpdateTimeFrameBulk({ input });

  return updateTimeFrameBulkResponseSelector(res);
};

export default updateTimeFrameBulk;
